import LabServiceModel from "@/models/LabServiceModel";
import LaboratoryModel from "@/models/lab/LaboratoryModel";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import SampleTypeCollection from "@/collections/lab/SampleTypeCollection";
import TestTaskCollection from "@/collections/lab/TestTaskCollection";
import TestWorkflowCollection from "@/collections/lab/TestWorkflowCollection";
import SampleCollection from "@/collections/lab/SampleCollection";

export default class TestProcessModel extends LabServiceModel {
  modelName() {
    return "test-process";
  }
  icon() {
    return "puzzle-piece";
  }
  isPrep() {
    return false;
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      sample_type_id: null,
      sample_type: null,
      name: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      test_tasks: {},
      schedulable_tasks: {},
      allocatable_samples: {},
      test_workflows: {}
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      laboratory_id: val => this.nullStringMutator(val),
      sample_type_id: (val) => (this.nullStringMutator(val)),
      name: val => this.nullStringMutator(val),
      description: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, "laboratory");
  }
  getSampleType() {
    return this.getRelatedModel(SampleTypeModel, 'sample_type');
  }
  getTestWorkflows() {
    return this.getRelatedCollection(
      new TestWorkflowCollection(),
      "test_workflows"
    );
  }
  getTestTasks() {
    return this.getRelatedCollection(new TestTaskCollection(), "test_tasks");
  }
  getAllocatableSamples() {
    return this.getRelatedCollection(
      new SampleCollection(),
      "allocatable_samples"
    );
  }
}
